
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SessionTimeoutManager from './SessionTimeoutManager';
import PopupService from '../PopupService'; // Import PopupService

const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [sessionManager, setSessionManager] = useState(null);

    const handleSessionTimeout = () => {
        // Clear authentication data
        localStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('username');

        // Show timeout message using PopupService
        PopupService.getInstance().showMessage(
            'Your session has expired due to inactivity. Please log in again.',
            false,
            5000
        );

        // Redirect to login page after a short delay
        setTimeout(() => {
            navigate('/login');
        }, 500); // Increased delay to ensure popup is visible
    };

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

        if (isLoggedIn) {
            const manager = new SessionTimeoutManager(30 * 60 * 1000, handleSessionTimeout);
            manager.start();
            setSessionManager(manager);
        }

        return () => {
            if (sessionManager) {
                sessionManager.stop();
            }
        };
    }, [navigate]); // Make sure to include all dependencies

    return <>{children}</>;
};

export default AuthProvider;
